/**
 * Centralized breakpoint definitions for responsive design.
 * Change these values to adjust when the app switches to mobile layout.
 */
export const BREAKPOINTS = {
  /** Max width (in px) that counts as "mobile" */
  mobile: 768,
} as const;

/** Keep in sync with _breakpoints.scss */
export const MEDIA_QUERIES = {
  /**
   * Devices that cannot hover — the exact query the `no-hover` mixin uses, so the SCSS and TS sides
   * can't disagree.
   *
   * Stated negatively on purpose. A browser that doesn't implement the `hover` feature matches
   * neither `(hover: hover)` nor `(hover: none)`, so asking the negative question and inverting the
   * answer is what makes both sides fail toward "can hover" together. Asking `(hover: hover)`
   * directly would fail toward "no hover" in TS while the SCSS still failed toward hover.
   *
   * The axis is independent of `mobile` above — see `useHasHover`.
   */
  noHover: '(hover: none)',
} as const;

/** Keep in sync with _breakpoints.scss */
export const MOBILE_SELECTION_BAR = {
  height: 44,
  gap: 8,
} as const;
